import { counters } from './counters';
import { visits } from './visits';
import { channelReport } from './channel-report';

export const tracking = {
	counters,
	visits,
	channelReport
};
